import { CurrencyTypeEnum } from '../../../model/currency_type.enum';
import { DataLabelEnum } from '../../../model/data_label.enum';

import { DefaultRequest } from './default';

class TokenDataRequest implements DefaultRequest {
  jsonrpc: string;
  method: string;
  id: string;
  params: TokenDataParams;

  constructor(id: string, currency: CurrencyTypeEnum, label: DataLabelEnum) {
    this.id = id;
    this.jsonrpc = '2.0';
    this.method = 'subscribe.ticker';
    this.params = new TokenDataParams(currency, label);
  }
}

class TokenDataParams {
  symbol: string;

  constructor(currency: CurrencyTypeEnum, label: DataLabelEnum) {
    this.symbol = `${currency}-${label}`;
  }
}

export { TokenDataRequest };
